import { useEffect } from 'react';

const useJumpLink = () => {
  useEffect(() => {
    const { hash } = window.location;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView(true);
        window.scrollBy(0, 0);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, []);
};

export default useJumpLink;
